import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { IonicVue } from '@ionic/vue'
import router from './router'

// Import Leaflet CSS
import 'leaflet/dist/leaflet.css'

import App from './App.vue'

// Global error handler
window.onerror = function(message, source, lineno, colno, error) {
  console.error('🚨 Global error caught:')
  console.error('Message:', message)
  console.error('Source:', source)
  console.error('Line:', lineno, 'Column:', colno)
  console.error('Error object:', error)
  return false
}

// Unhandled promise rejection handler
window.onunhandledrejection = function(event) {
  console.error('🚨 Unhandled promise rejection:')
  console.error('Reason:', event.reason)
  console.error('Promise:', event.promise)
}

console.log('🚀 Application starting...')

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(IonicVue)
app.use(router)

// Initialize auth store to restore session
import { useAuthStore } from './stores/auth'
import { useTripStore } from './stores/trip'
import { useSettingsStore } from './stores/settings'

// Initialize settings first (theme, language)
const settingsStore = useSettingsStore()
console.log('⚙️ Loading settings...')
settingsStore.loadSettings()
settingsStore.initializeThemeListener()
console.log('✓ Settings loaded')

const authStore = useAuthStore()
console.log('🔐 Initializing auth store...')

authStore.initialize().then(() => {
  console.log('✓ Auth store initialized')
  
  // Initialize network monitoring
  console.log('📡 Initializing network monitoring...')
  import('./services/offline').then(({ initializeNetworkMonitoring }) => {
    initializeNetworkMonitoring().then(() => {
      console.log('✓ Network monitoring initialized')
    }).catch((error) => {
      console.warn('⚠️  Network monitoring failed to initialize:', error)
    })
  })
  
  // Initialize trip store if user is authenticated
  if (authStore.isAuthenticated && authStore.user) {
    console.log('🗺️  Initializing trip store...')
    const tripStore = useTripStore()
    tripStore.initialize(authStore.user.id).then(() => {
      console.log('✓ Trip store initialized')
    })
    
    // Initialize vehicle store
    console.log('🚗 Initializing vehicle store...')
    import('./stores/vehicle').then(({ useVehicleStore }) => {
      const vehicleStore = useVehicleStore()
      vehicleStore.initialize(authStore.user!.id).then(() => {
        console.log('✓ Vehicle store initialized')
      })
    })
    
    // Initialize push notifications
    console.log('🔔 Initializing push notifications...')
    import('./services/notifications').then(({ initializePushNotifications }) => {
      initializePushNotifications(authStore.user!.id).then(() => {
        console.log('✓ Push notifications initialized')
      }).catch((error) => {
        console.warn('⚠️  Push notifications failed to initialize:', error)
      })
    })
  }
})

console.log('�🚀 App mounting...')
app.mount('#app')
console.log('🚀 App mounted')